import {useState} from "react";
import {useTranslation} from "react-i18next";
import {toast} from "react-toastify";
import {useDispatch, useSelector} from "react-redux";
import HandleChange from "../../../../../Helpers/HandleChange";
import {ValidateIdentity} from "../../../../../reduxToolkit/CompanyEmployees/CompanyEmployeesApi";
import {errorMsg} from "../../../../../Apis/functions";
import {STATUS_MODEL} from "../../../../../enums/statusEnum";

/**
 * @email kpozos@ibl.mx
 * @author Karen Yunuen Pozos Arias
 * @jobTitle Full Stack Developer
 *
 * @component UpdateIdentityValidationModalApp
 * @description Handles the logic for validating a user's identity status from a modal.
 *              It captures the reason, validates the form, and sends the request to update the identity status.
 *
 * @param {string|number} userId - Unique identifier of the user whose identity is being validated.
 * @param {Function} setModified - Callback to notify parent that data has changed (e.g., to refresh a table).
 * @param {string|number} status - Identity validation status to be assigned (e.g., VALIDATED, REJECTED).
 * @param {Function} onHide - Function to close or hide the modal.
 * @param {string} successTrans - Success message to show after successful validation.
 *
 * @returns {Object} Modal handler object containing state and functions to control the modal.
 */

export const UpdateIdentityValidationModalApp = ({userId, setModified, status, onHide, successTrans}) =>{

    const [emptyFields, setEmptyFields] = useState(false);
    const [data, setData] = useState({reason: ""});
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const approverId = useSelector((state) => state.authenticatioauthennSlice.getUserByIdAtEntry.userId);

    const { handleChange } = HandleChange({ model: data, setModel: setData });

    const resetValues = () =>{
        setData({reason: ""});
    }

    const handleCreate = () => {
        if (status !== STATUS_MODEL.VALIDATED && data.reason === "") {
            setEmptyFields(true);
            return;
        }

        const body = {
            id: userId,
            identityValidation:{
                id: status
            },
            identityValidationApprover:{
                id: approverId
            },
            identityValidationReason: data.reason === "" ? null: data.reason
        };

        dispatch(ValidateIdentity(body)).then(
            ({ payload: { data: { data, code } } }) => {
                if (data) {
                    resetValues();
                    toast.success(t(successTrans));
                    setModified(true);
                    onHide()
                } else {
                    errorMsg(code);
                }
            }
        );

        setEmptyFields(false);
    };

    return {
        resetValues,
        emptyFields,
        handleChange,
        t,
        handleCreate,
        data
    }
}
